/**
* @file 营销管理-顶部广告
* */ 
<template>
  <div id="top">
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" 
      :addText="$refs.customTable && $refs.customTable.table.total >= 10 ? '' : '新增广告'" @addFn="visibleDrawer = true"
      :paging="false">
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="160px">
          <div slot-scope="{row}" class="custom-action">
            <template v-if="row.defaultBanner">
              <div style="color: #999;">(默认不可编辑)</div>
            </template>
            <template v-else>
              <el-tooltip content="编辑" placement="top">
                <i class="iconfont icon-compile" @click="advertisingClick(row)"></i>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <i class="iconfont icon-delete" @click="removeClick(row)"></i>
              </el-tooltip></template>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <template v-if="item.prop == 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop == 'coverImg'">
          <img :src="mixinQiniuImg(row.coverImg, 343, 126)" style="width: 171.5px; height: 63px;" alt="">
        </template>
        <template v-else-if="item.prop == 'status'">
          <div class="custom-switch" @click="switchClick(row)">
            <el-switch disabled v-model="row.status" :active-value="1" :inactive-value="2"></el-switch>
          </div>
        </template>
        <template v-else-if="item.prop === 'jumpTo'">
          <div v-if="row.jumpType == 5">{{ row.jumpTo ? JSON.parse(row.jumpTo).name : '-' }}</div>
          <div v-else>{{row.jumpTo || '-'}}</div>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>
    </custom-table>

    <el-drawer :visible.sync="visibleDrawer" :before-close="advertisingClose">
      <topForm :visible.sync="visibleDrawer" :id="id" @advertisingClose="advertisingClose" />
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "top",
  components: {
    topForm: () => import("./topForm")
  },
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/banner/ad'
      },
      // 表头
      columns: [
        { prop: 'coverImg', label: '封面图片' },
        { prop: 'created', label: '创建时间' },
        { prop: 'status', label: '是否启用' },
        { prop: 'jumpTo', label: '跳转页面' }
      ],

      visibleDrawer: false,
      id: null
    }
  },

  methods: {
    advertisingClick(row) {
      this.visibleDrawer = true;
      this.id = row.id;
    },
    advertisingClose() {
      this.visibleDrawer = false;
      this.id = null;
      this.$refs.customTable.listFn();
    },


    /* 开关 */
    switchClick(row) {
      this.$confirm(`确认要${row.status == 1 ? '关闭' : '开启'}吗?`, '提示').then(async () => {
        let status = row.status == 1 ? 2 : 1
        this.putFn(row, status)
      })
    },

    /* 接口请求-编辑 */
    async putFn(row, status) {
      let url = '/api/v1/manage/banner/ad';
      let params = Object.assign(row, { status });
      let data = await this.$axios.put(url, params);
      if (data && data.code == 1) {
        this.$message.success(`已${row.status == 1 ? '开启' : '关闭'}`);
        this.$refs.customTable.listFn();
      } else {
        row.status = row.status == 1 ? 2 : 1;
      }
    },

    /* 列表-删除 */
    removeClick(row) {
      let text = row.coverImg == 1 ? '删除后广告将不可见，确认删除吗?' : '确认要删除该广告吗?';
      this.$confirm(text, '删除提示').then(async () => {
        let url = '/api/v1/manage/banner/ad';
        let params = {
          id: row.id
        }
        let data = await this.$axios.delete(url, params);
        if (data && data.code == 1) {
          this.$message.success('删除成功');
          this.$refs.customTable.listFn()
        }
      })
    }
  }
}
</script>

<style lang="less">
#top {
  .search-top-left {
    font-weight: 600;

    .second {
      color: #999;
    }

    .set {
      margin-left: 10px;
    }
  }

  .el-input {
    width: auto;
  }

  .el-table .cell.el-tooltip {
    display: flex;
  }

  // 封面图片样式
  .el-table {
    img {
      border-radius: 6px;
      object-fit: cover;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    }
  }

  // 操作按钮样式
  .custom-action {
    display: flex;
    align-items: center;
    gap: 12px;
    
    .iconfont {
      font-size: 16px;
      cursor: pointer;
      transition: all 0.2s;
      
      &.icon-compile {
        color: #2B77FF;
        
        &:hover {
          color: #1a5fd9;
        }
      }
      
      &.icon-delete {
        color: #F56C6C;
        
        &:hover {
          color: #c45656;
        }
      }
    }
  }
}
</style>
